import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Tools(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M20.402 14.567a3.54 3.54 0 01-2.268 5.442l-9.91 1.929a3.54 3.54 0 11-1.353-6.95l5.858-1.14-1.176-3.528c-.938-2.746-.55-4.78.17-6.159a5.859 5.859 0 011.106-1.489 4.86 4.86 0 01.569-.472l.046-.031.016-.01.006-.004.003-.002c.001-.001.002-.002.531.847l-.529-.849a1 1 0 011.438.432l5.493 11.984zm-5.694-1.104l-1.262-3.786c-.77-2.253-.406-3.717.05-4.588.065-.125.133-.24.203-.346l3.781 8.25c-.23 0-.464.02-.7.066l-2.072.404zm2.455 1.56a1.54 1.54 0 01.588 3.023l-9.91 1.929a1.54 1.54 0 11-.588-3.024l9.91-1.929z",
    clipRule: "evenodd"
  }));
}

export default Tools;